var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 6.3125C13.375 6.48958 13.3125 6.65625 13.1875 6.78125L7.53125 12.4375C7.40625 12.5625 7.22917 12.6354 7.05208 12.6354C6.88542 12.6354 6.70833 12.5625 6.58333 12.4375L2.8125 8.66667C2.6875 8.54167 2.625 8.375 2.625 8.19792C2.625 8.02083 2.6875 7.84375 2.8125 7.71875L3.76042 6.78125C3.88542 6.65625 4.05208 6.58333 4.22917 6.58333C4.40625 6.58333 4.57292 6.65625 4.69792 6.78125L7.05208 9.13542L11.3021 4.89583C11.4271 4.77083 11.5937 4.69792 11.7708 4.69792C11.9479 4.69792 12.1146 4.77083 12.2396 4.89583L13.1875 5.83333C13.3125 5.95833 13.375 6.13542 13.375 6.3125ZM16 8C16 3.58333 12.4167 0 8 0C3.58333 0 0 3.58333 0 8C0 12.4167 3.58333 16 8 16C12.4167 16 16 12.4167 16 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.b5b9c1f4125dd2d957925a6e589db355.svg";
export { ForwardRef as ReactComponent };